module.exports = __webpack_public_path__ + "img/user-ilon.e23267de.svg";